import useLastCallback from '@hooks/use-last-callback';
import { useCallback } from 'react';
import type { BlockerFunction } from 'react-router-dom';
import { useBlocker } from 'react-router-dom';

export default function useHistoryBack(isActive: boolean, onBack: () => void) {
  const lastOnBack = useLastCallback(onBack);

  const processBack = useCallback(() => {
    lastOnBack();
  }, [lastOnBack]);

  const shouldBlock = useCallback<BlockerFunction>(
    ({ historyAction }) => {
      if (historyAction === 'POP' && isActive) {
        processBack();
        return true;
      }

      return false;
    },
    [isActive, processBack],
  );

  useBlocker(shouldBlock);
}
